import { useTranslation } from 'react-i18next'
import { encodePlusCode } from '@/lib/plusCode'
import { CopyButton } from '@/components/ui/copy-button'
import { cn } from '@/lib/utils'

/**
 * Item 246 — one inline line: a "Plus Code" label, the code, and a copy button.
 * Renders nothing when no code can be computed. Colours inherit from `className` so the
 * line reads the same inside the map's light cards and in the themed dialogs.
 */
export function PlusCode({
  lat,
  lng,
  copyable = true,
  className,
}: {
  lat: number
  lng: number
  /** Off inside a hover card, which cannot take a click. */
  copyable?: boolean
  className?: string
}) {
  const { t } = useTranslation('common')
  const code = encodePlusCode(lat, lng)
  if (!code) return null
  return (
    <span className={cn('inline-flex min-w-0 items-center gap-1.5 text-xs text-muted-foreground', className)}>
      <span className="text-[10px] font-semibold uppercase tracking-wide opacity-70">{t('plusCode')}</span>
      <span className="font-mono">{code}</span>
      {copyable && <CopyButton value={code} label={t('plusCode')} />}
    </span>
  )
}
